export default "/assets/images/icon-shield.8e4caf31dc8515a2.svg";